import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { handleRequest } from '../quipli-service-client';
import { AxiosRequestConfig } from 'axios';
import { OrdersTotals } from '../../../admin/order/order-utils';
import { OrderSearchRequest, SearchDispatchRequest } from '../order/order';

export const useReportApiV1 = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function exportTransactionsReport(request: OrderSearchRequest): Promise<BlobPart> {
    const config: AxiosRequestConfig = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/reports/transactions/export`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
      responseType: 'blob',
    };

    return await handleRequest(config, true);
  }

  async function getOrdersResume(params: OrderSearchRequest): Promise<OrdersTotals> {
    const config: AxiosRequestConfig = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/reports/transactions/resume`,
      headers: {
        'X-Tenant': tenant,
      },
      data: params,
    };

    return await handleRequest(config);
  }

  async function exportDispatchList(request: SearchDispatchRequest): Promise<BlobPart> {
    const config: AxiosRequestConfig = {
      method: 'post',
      url: `${contextPath}quipli-service/v2/reports/driverDispatch`,
      headers: {
        'X-Tenant': tenant,
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      },
      data: request,
      responseType: 'blob',
    };

    return await handleRequest(config, true);
  }

  return {
    exportTransactionsReport,
    getOrdersResume,
    exportDispatchList,
  };
};
